<template>
  <div class="table-name g-flex g-flex-sb  g-table-header g-pt-10 g-pb-10 table-computed__ele">
    <h1>
      {{ name }}
      <slot name="tip"/>
    </h1>
    <div class="g-flex">
      <rich-text/>
      <slot/>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'table-name',
    props: {
      name: {
        type: String,
        default: '每页的标题名称'
      }
    }
  };
</script>

<style scoped lang='scss'>
  .table-name {
    h1 {
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      font-weight: normal;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/table-name/index.vue